import { type ResponseErrorGenerics } from '@dni-types/utilities/response'
import { createMutationHelper } from '@utils/swr'
import { type AxiosError } from 'axios'
import {
  type CreatePaymentTransactionsRequest,
} from '../types/apiRequest'
import { type CreatePaymentTransactionsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

export type UseApiFpCretePaymentTransactionProps = AxiosError<{
  error: ResponseErrorGenerics<{
    product_id?: number
    product_name?: string
    left_quantity?: number
  }>
}>

const { useMutation } = createMutationHelper<FortuneApis['post']['paymentTransactions'], CreatePaymentTransactionsResponse, CreatePaymentTransactionsRequest, { campaign_code?: string }, UseApiFpCretePaymentTransactionProps>({
  client: 'fortune',
  key: (params) => {
    const { campaign_code } = params || {}
    if (!campaign_code) return null
    return `/campaigns/${campaign_code}/payment_transactions`
  },
  fetcher: (url, { client, arg }) => client.post(url, arg, {
    headers: arg.headers,
  }),
})

export const useApiFpCretePaymentTransaction = useMutation
